// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper_2A6Np","iframe":"index_iframe_3Nl4Z"};